import styles from './SignalChannels.module.css';

export default function SignalChannels() {
  return (
    <div className={styles.root}>
      <h3>SIGNAL CHANNELS</h3>
      <div className={styles.info}>
        <label>BOOKING</label>
        <span><a href="mailto:moctpromo@gmail.com">moctpromo@gmail.com</a></span>
        <label>PRESS</label>
        <span><a href="mailto:press@moct.am">press@moct.am</a></span>
        <label>GENERAL</label>
        <span><a href="mailto:hello@moct.am">hello@moct.am</a></span>
        <label>INSTAGRAM</label>
        <span>
          <a href="https://instagram.com/moct_yerevan" target="_blank" rel="noreferrer">
            @moct_yerevan
          </a>
        </span>
        <label>FACEBOOK</label>
        <span>
          <a href="https://facebook.com/MOCTyerevan" target="_blank" rel="noreferrer">
            /MOCTyerevan
          </a>
        </span>
      </div>

      <h3 style={{ marginTop: 16 }}>VENUES</h3>
      <div className={styles.info}>
        <label>HAYFILM</label>
        <span>ASHTARAK HWY 30, YEREVAN</span>
        <label>COORDS</label>
        <span>40.2098N / 44.4880E</span>
        <label>STAGES</label>
        <span>MAIN / BLUE / BROWN / PROJECTOR ROOM</span>
        <label>AYRARAT</label>
        <span>SAYAT-NOVA AVE 40, YEREVAN</span>
        <label>COORDS</label>
        <span>40.1810N / 44.5145E</span>
      </div>

      <h3 style={{ marginTop: 16 }}>LEGAL</h3>
      <p className={styles.legal}>
        STRICTLY 18+. FACE CONTROL ENFORCED. NO PHONES ON DANCEFLOOR. NO REFUNDS AFTER WAVE
        OPENS. ORGANIZER MAY REVOKE ENTRY WITH IMMEDIATE REFUND.
      </p>
    </div>
  );
}
